import React, { useState, useRef } from 'react'; import axios from 'axios' ;
import Cookies from 'universal-cookie'; 
import Swal from 'sweetalert2'; import withReactContent from 'sweetalert2-react-content';
import useOrientation from '../../../general/useOrientation';

const cookies = new Cookies();
const MySwal = withReactContent(Swal)
// onChanged (opsional): dipanggil dengan nilai baru setelah server sukses, supaya tabel induk ikut menyimpannya.
// Tanpa itu, baris yang di-mount ulang (ganti halaman / search) kembali memakai nilai lama dari data awal halaman.
function SwitchOnOff({setLoading,initialActive,data,link,onChanged}) {
  const [active, setActive] = useState(initialActive); 
  const isSending = useRef(false);
  const orientation = useOrientation();
  let isThisPortrait = false;
  if (orientation === 'portrait') { isThisPortrait = true;}
  
  const changeData = () => {
    //alert(`${process.env.REACT_APP_PATH_DESTINATION}/${link}/active/${data}`);
    // Klik kedua selagi request pertama belum selesai diabaikan (endpoint yang membalik nilai = 2 klik balik lagi).
    if (isSending.current) return;
    isSending.current = true;
    const nextActive = 1 - active;
    setLoading(true);
    var sessionToken = cookies.get('sessionToken', { path: '/' })
    axios.interceptors.request.use(config => {config.headers['x-access-token'] = sessionToken;return config;},error => {return Promise.reject(error);});
    // ?set= = posisi yang dipilih user; endpoint tenant memakainya (set, bukan balik), endpoint lain mengabaikannya.
    axios.get(`${process.env.REACT_APP_PATH_DESTINATION}/${link}/active/${data}?set=${nextActive}`)
      .then(res => {
        console.log(res.data.data);
        isSending.current = false;
        setLoading(false);
        // Middleware/handleResponse menolak dengan HTTP 200 + status '300'/'401'/'403'; jangan ubah tombol kalau tidak tersimpan.
        if (res.data.status !== '200') {
          MySwal.fire({
            title: <strong>Error!</strong>,
            html: <p>{res.data.message || "Status tidak tersimpan. Coba refresh / login ulang"}</p>
          })
          return;
        }
        setActive(nextActive)
        if (onChanged) onChanged(nextActive);
      })
      .catch(err => {
        console.log(err);
        isSending.current = false;
            MySwal.fire({
            title: <strong>Error!</strong>,
            html: <p>{err.response?.data?.message || "An error occurred. Please try relogging"}</p>
        })
        setLoading(false);
      })
  }
  return (
    <img 
        src={active == 1 ? 
            process.env.REACT_APP_SELF_PATH_DESTINATION+"/SwitchOn.png" : 
            process.env.REACT_APP_SELF_PATH_DESTINATION+"/SwitchOff.png"} 
        alt="Switch On Off" 
        style={{height:isThisPortrait?"2vh":"2vw"}}
        onClick={changeData}
    />
  )
}

export default SwitchOnOff